<script lang="ts">
  import type { JobItem } from "../../../app/store/store-careers";
  import SkillTag from "./SkillTag.svelte";

  export let data: JobItem;
</script>

<div class="job-card relative z-0">
  <div class="background" />

  <div class="relative py-5 px-8 rounded bg-white z-10">
    <div class="typo-heading-4 text-dark-200">
      {data.title}
    </div>

    <div class="mt-2 leading-loose font-normal text-dark-50">
      {data.description}
    </div>

    <div class="flex flex-row items-center flex-wrap mt-4 gap-3">
      {#each data.requiredSkills as skill}
        <SkillTag {skill} />
      {/each}
    </div>
  </div>
</div>

<style lang="postcss">
  .background {
    @apply absolute rounded-lg z-0;
    left: 16px;
    right: 16px;
    top: 16px;
    bottom: -12px;
    background: #3754aa;
    opacity: 0.12;
    filter: blur(40px);
    -webkit-backdrop-filter: blur(40px);
  }
</style>
